// extracted by mini-css-extract-plugin
module.exports = {"Value":"Gauge_Value__1MIYQ","Small":"Gauge_Small__1aITf","Unit":"Gauge_Unit__1Mzi-"};